import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, SectionTitle } from '../../components/ui';

// Gambar untuk gallery (dari folder images)
const galleryImages = [
  { src: require('../../images/Banner-Aman-Mart-1.png'), alt: 'Aman Mart' },
  { src: require('../../images/Buah-dan-Sayuran.png'), alt: 'Buah dan Sayuran' },
  { src: require('../../images/Makanan-dan-Minuman.png'), alt: 'Makanan dan Minuman' },
  { src: require('../../images/Pakaian-dan-Mode.png'), alt: 'Pakaian dan Mode' },
  { src: require('../../images/Perlengkapan-Bayi.png'), alt: 'Perlengkapan Bayi' },
  { src: require('../../images/Perlengkapan-Rumah-Tangga.png'), alt: 'Perlengkapan Rumah Tangga' },
];

// Video kegiatan dari folder public/videos (nama file yang ditampilkan)
const videoFiles = ['kegiatan-1.mp4', 'kegiatan-2.mp4', 'kegiatan-3.mp4'];
const baseVideoPath = process.env.PUBLIC_URL || '';

export default function TentangKami() {
  return (
    <main className="min-h-screen">
      {/* Hero judul halaman */}
      <section className="py-16 md:py-20 bg-green-to-white-hero">
        <Container>
          <div className="text-center max-w-2xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-extrabold text-am-text-900 font-display">
              Tentang Kami
            </h1>
            <p className="mt-4 text-am-text-700 text-lg">
              Mengenal lebih dekat PT AMANAH MULIA NIAGA.
            </p>
          </div>
        </Container>
      </section>

      {/* Cerita & profil */}
      <section className="py-16 bg-white">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <SectionTitle title="Siapa Kami" />
              <p className="mt-4 text-am-text-700 leading-relaxed">
              PT AMANAH MULIA NIAGA berdiri pada Desember 2023, berkantor di Plaza HNI,
                Jalan Raya Kalimalang – Billymoon, Pondok Kelapa, Duren Sawit, Jakarta Timur.
              </p>
              <p className="mt-4 text-am-text-700 leading-relaxed">
              PT AMANAH MULIA NIAGA menyediakan kebutuhan sehari-hari untuk perseorangan, rumah tangga, katering,
                rumah makan, dan institusi lainnya dengan jaminan barang pilihan, terjangkau, lengkap,
                dan tentunya halal yang telah terlisensi oleh BPOM MUI dan lembaga resmi pemerintah
                lainnya. Kami menamai gerai kami dengan <strong>Amanstore</strong>.
              </p>
            </div>
            <div className="flex justify-center lg:justify-end">
              <img
                src={require('../../images/Banner-Aman-Mart-1.png')}
                alt="Aman Mart"
                className="w-full max-w-md rounded-xl shadow-lg object-cover"
              />
            </div>
          </div>
        </Container>
      </section>

      {/* Nilai / visi (opsional) */}
      <section className="py-16 bg-am-green-50/50">
        <Container>
          <SectionTitle
            title="Komitmen Kami"
            subtitle="Melayani dengan amanah dan kualitas terjamin."
            align="center"
            className="mb-12"
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md border border-am-green-50 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-am-accent/10 flex items-center justify-center text-am-accent font-bold text-xl">
                ✓
              </div>
              <h3 className="mt-4 font-semibold text-am-text-900">Halal & Terjamin</h3>
              <p className="mt-2 text-sm text-am-text-700">
                Produk berlisensi BPOM MUI dan lembaga resmi.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-am-green-50 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-am-accent/10 flex items-center justify-center text-am-accent font-bold text-xl">
                ✓
              </div>
              <h3 className="mt-4 font-semibold text-am-text-900">Terjangkau</h3>
              <p className="mt-2 text-sm text-am-text-700">
                Harga bersaing untuk kebutuhan harian Anda.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-am-green-50 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-am-accent/10 flex items-center justify-center text-am-accent font-bold text-xl">
                ✓
              </div>
              <h3 className="mt-4 font-semibold text-am-text-900">Lengkap</h3>
              <p className="mt-2 text-sm text-am-text-700">
                Beragam kategori dari sembako hingga perlengkapan rumah.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Gallery: gambar + video kegiatan (portrait) */}
      <section className="py-16 bg-white">
        <Container>
          <SectionTitle
            title="Gallery Kami"
            subtitle="Momen dan kegiatan Aman Mart."
            align="center"
            className="mb-10"
          />

          {/* Galeri gambar */}
          <div className="mb-14">
            <h3 className="text-lg font-semibold text-am-text-900 mb-4">Gambar</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {galleryImages.map((img, i) => (
                <div
                  key={i}
                  className="aspect-square rounded-xl overflow-hidden shadow-md border border-am-green-50 hover:shadow-lg transition-shadow"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Video kegiatan (portrait) */}
          <div>
            <h3 className="text-lg font-semibold text-am-text-900 mb-4">Video Kegiatan</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {videoFiles.map((filename, i) => (
                <div
                  key={filename}
                  className="flex flex-col items-center"
                >
                  <div className="w-full max-w-[240px] mx-auto aspect-[9/16] rounded-xl overflow-hidden bg-am-green-50 border border-am-green-100 shadow-md">
                    <video
                      src={`${baseVideoPath}/videos/${filename}`}
                      controls
                      playsInline
                      className="w-full h-full object-cover"
                      poster=""
                      preload="metadata"
                    >
                      Browser Anda tidak mendukung pemutaran video.
                    </video>
                  </div>
                  <p className="mt-2 text-sm text-am-text-700 font-medium">
                    Kegiatan {i + 1}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* CTA kembali ke beranda */}
      <section className="py-16 bg-white">
        <Container>
          <div className="text-center">
            <p className="text-am-text-700 mb-6">
              Tertarik berbelanja? Lihat kategori produk kami.
            </p>
            <Link to="/">
              <Button variant="primary" size="lg">
                Kembali ke Beranda
              </Button>
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
}
